<template>
    <div class="row">
        <div class="col-md-12 mb-1">
            <label class="form-label">Aylak İli</label>
            <v-select-list v-model="value.Province" :options="provinces" label="Name" v-on:input="getDistricts" placeholder="Aylak İli"></v-select-list>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Aylak İlçesi</label>
            <v-select-list :disabled="!value.Province" v-model="value.District" :options="districts" label="Name" placeholder="Aylak İlçesi" v-on:input="getNeighbourhood"></v-select-list>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Aylak Mahallesi</label>
            <v-select-list :disabled="!value.District" v-model="value.Neighbourhood" :options="neighbourhoods" label="Name" placeholder="Aylak Mahallesi"></v-select-list>
        </div>
        <div class="col-md-12">
            <div class="map-wrapper" :class="{'disabled':c_disableAdd}">
                <google-maps-find-location :address="address" v-on:location="value.LatLng = $event"></google-maps-find-location>
            </div>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import GoogleMapsFindLocation from '@/components/GoogleMapsFindLocation'
export default {
    props:{
        value:Object
    },
    components:{
        GoogleMapsFindLocation
    },
    data(){
        return{
            provinces:[],
            districts:[],
            neighbourhoods:[],
        }
    },
    mounted(){
        this.getProvinces()
    },
    watch:{
        "value.Province":{
            handler(){
                this.value.District = null
                this.value.Neighbourhood = null 
            }
        },
        "value.District":{
            handler(){
                this.value.Neighbourhood = null 
            }
        }
    },
    methods:{
        getProvinces(){
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(){
            if(this.value.Province?.Id){
                SystemDataApi.District(this.value.Province.Id)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
        },
        getNeighbourhood(){
            if(this.value.District?.Id){
                SystemDataApi.Neighborhood(this.value.District.Id)
                .then(res=>{
                    this.neighbourhoods = res.data.Data
                })
            }
        }
    },
    computed:{
        address(){
            return [
                this.value.Province?.Name || '',
                this.value.District?.Name || '',
                this.value.Neighbourhood?.Name || ''
            ].join(',')
        },
        c_disableAdd(){
            return !this.value.Province || !this.value.District || !this.value.Neighbourhood
        }
    }

}
</script>

<style>
.map-wrapper{
    height: 300px;
}
.map-wrapper.disabled{
    opacity: 0.5;
    pointer-events: none;
}
</style>